import Icon from "components/icon";

export const SendButton = defineComponent<{
  disabled?: boolean;
  onClick?: () => void;
}>(
  (props) => {
    return () => {
      const disabled = !!props.disabled;
      const handleClick = () => {
        if (disabled) return;
        props.onClick?.();
      };
      return (
        <div
          onClick={handleClick}
          class={[
            "w-6 h-6 px-[3px] py-[5px] flex items-center justify-center select-none transition-colors",
            disabled ? "text-gray-400 cursor-not-allowed" : "cursor-pointer",
          ]}
        >
          <Icon
            fill="currentColor"
            size="1rem"
            src={async () => import("assets/img/svg/icons/paper-plane.svg?raw")}
          />
        </div>
      );
    };
  },
  { props: ["disabled", "onClick"] },
);
